<template>
  <div class="navbar">
    <hamburger id="hamburger-container" :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />

    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />
    <el-form :inline="true" label-width="126px" style="float:left;">
      <div class="el-form-item" style="position: relative;">
        <label class="el-form-item__label" style="width: 126px;">
          【系统是否可用 <el-popover
          popper-class="question-popover"
          placement="bottom-end"
          width="200"
          trigger="hover"
          content="如果为不可用 商户端不可通过接口提交订单。">
          <svg-icon slot="reference" class="question-ico" icon-class="explain-icon"></svg-icon>
        </el-popover>
        </label>
        <div class="el-form-item__content">
          <div class="w220"> <i class="placeholder"></i>：
            <span v-if="parseInt(sysInfo.enable)===1&&parseInt(dateDiff(formatDate(sysInfo.currentTime),formatDate(sysInfo.expireTime)))===0" class="text-red">禁用</span>
            <span v-else-if="parseInt(sysInfo.enable)===0" class="text-red">禁用</span>
            <span v-else-if="parseInt(sysInfo.enable)===1" class="text-green">可用</span>
            <span v-else class="text-red">{{sysInfo.enable}}</span>
          </div>
          </div>
      </div>
      <el-form-item label="最近续费时间:">
        <div class="w220">
          <span v-if="sysInfo.lastPayTime&&sysInfo.lastPayTime.indexOf('获取状态异常')===0" class="text-red">{{sysInfo.lastPayTime}}</span>
          <span v-else>{{sysInfo.lastPayTime}}</span>
        </div>
      </el-form-item>
      <el-form-item label="过期时间:" style="margin-left:-30px;">
        <div class="w220">
          <span :class="sysInfo.expireTime&&sysInfo.expireTime.indexOf('获取状态异常')!==0?'':'text-red'">{{sysInfo.expireTime}}</span>
          <template v-if="sysInfo.expireTime&&sysInfo.expireTime.indexOf('获取状态异常')!==0">
            <span v-if="parseInt(dateDiff(formatDate(sysInfo.currentTime),formatDate(sysInfo.expireTime)))>0">距离过期：<b class="text-red">{{dateDiff(formatDate(sysInfo.currentTime),formatDate(sysInfo.expireTime))}}天</b></span>
            <span class="text-red" v-else>已过期</span>
          </template>
          】
        </div>
      </el-form-item>
    </el-form>
    <div class="right-menu">
      <template v-if="device!=='mobile'">
        <search id="header-search" class="right-menu-item" />
      </template>

      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
        <div class="avatar-wrapper">
          <!--<img :src="user.avatarName ? baseApi + '/avatar/' + user.avatarName : Avatar" class="user-avatar">-->
          <img :src="Avatar" class="user-avatar">
          <span class="username" style="vertical-align: top;">{{ user.name }}</span>
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <span style="display:block;" @click="show = true">
            <el-dropdown-item>布局设置</el-dropdown-item>
          </span>
          <router-link to="/member/profile/index">
            <el-dropdown-item>个人中心</el-dropdown-item>
          </router-link>
          <span style="display:block;" @click="open">
            <el-dropdown-item divided>退出登录</el-dropdown-item>
          </span>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import Hamburger from '@/components/Hamburger'
import Breadcrumb from '@/components/Breadcrumb'
import Search from '@/components/HeaderSearch'
import Avatar from '@/assets/avatar.png'
import { mapGetters } from 'vuex'
import indexApi from '@/api/index'
import baseTool from '@/utils/comFun'
import {formatDate, dateDiff} from '@/utils/index'
export default {
  components: {
    Hamburger,
    Breadcrumb,
    Search
  },
  data () {
    return {
      Avatar: Avatar,
      dialogVisible: false,
      sysInfo: {}
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'device',
      'user',
      'baseApi'
    ]),
    show: {
      get () {
        return this.$store.state.settings.showSettings
      },
      set (val) {
        this.$store.dispatch('settings/changeSetting', {
          key: 'showSettings',
          value: val
        })
      }
    }
  },
  created () {
    indexApi.getSysInfo().then((res) => {
      if (res.status === '000000') {
        this.sysInfo = res.data
      } else {
        baseTool.ErrorTipShow(this, res.msg)
      }
    })
  },
  methods: {
    formatDate,
    dateDiff,
    toggleSideBar () {
      this.$store.dispatch('app/toggleSideBar')
    },
    open () {
      this.$confirm('确定注销并退出系统吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.logout()
      }).catch((err) => {
        console.log('err', err)
      })
    },
    logout () {
      this.$store.dispatch('LogOut').then(() => {
        // window.location.reload()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color:transparent;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
  /deep/ .el-form-item {margin-right: 0 !important;}
  /deep/ .el-form-item__label,/deep/ .el-form-item__content{line-height:50px!important;}
  .question-ico {
    display: inline-block;
    width: 16px;
    height: 16px;
    vertical-align: top;
    margin: 2px 0 0 2px;
    cursor: pointer;
    fill:#b0b0b0;
    position: absolute;
    top:14px;
    &:hover{
      fill:#27baff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/Navbar.vue